import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { MT_ENTERPRISES } from '../mtEnterprises';
const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/service',
  ...addPermissionsToRoute(['mtService']),
  menuFilters: {
    $or: [
      // MT tenants (see mtEnterprises.js). Plain `TimHortons` is excluded.
      {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $in: MT_ENTERPRISES } },
        ],
      },
      {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    ],
  },
  children: [
    {
      path: '/reports/service/serviceTimesStatistics',
      name: 'Service Times Statistics',
      meta: { id: 'reports-mtServiceTimesStatistics' },
      component: () => import('./SpeedOfService.vue'),
    },
    {
      path: '/reports/service/serviceTimes',
      name: 'Service Times (Legacy)',
      meta: { id: 'reports-mtServiceTimes' },
      component: () => import('./ServiceTimeStatistics.vue'),
    },
  ],
};

export default routes;
